/* AddEditCredentialComponent.js */

"use strict";
const _ = require("lodash");
const Renderer = require("./AddEditCredentialRenderer");

class AddRangeComponent {
    constructor(logger, context, title, dropdownValues) {
        this._logger = logger;
        this._context = context;
        this._title = title || "Edit Credential";
        this._dropdownValues = dropdownValues;

        if (!_.isEmpty(this._context)) {
            if (_.get(this._context, "type", "") === "login") {
                this._type = _.get(this._context, "type", "login");
                this._credential = _.get(this._context, "credId", "login");
            } else {
                this._type = _.get(this._context, "type", "enableMode");
                this._enableMode = _.get(this._context, "credId", "login");
            }
        }

        this._renderer = new Renderer(this);
        this._renderer.render();
        this._context = undefined;
    }

    get renderer() {
        return this.getRenderer();
    }

    getRenderer() {
        return this._renderer;
    }

    shutdown() {
        return this._renderer.shutdown().then(
            () => {
                this._renderer = undefined;
                this._context = undefined;
            },
            (err) => {
                this._logger.warn({error: err}, "BaseCreateComponent.shutdown() error");
            }
        );
    }

    createAction(res) {
        this._context.resolve(res);
    }

    cancelAction() {
        this._context.reject({userRejected: true});
    }

    // prettier-ignore
    set "$teve.ui.context"(context) { //jshint ignore:line
      this._context = context;
    }
}
module.exports = AddRangeComponent;
